var map = {
	"./i18n/options.i18n.it-it.js": "dptT",
	"./i18n/ors-dictionary.i18n.it-it.js": "6X9W",
	"./i18n/ors-map-filters.i18n.it-it.js": "5Jc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4LOh";